module.exports = __webpack_public_path__ + "img/WechatIMG797.c9bd9511.jpg";